module.exports = __webpack_public_path__ + "img/Incorrect Diameter.50a79476.png";